<nav class="navbar navbar-expand-lg navbar-transparent  navbar-absolute fixed-top">
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <a id="page_title" class="navbar-brand" href="#">{{getTitle()}}</a>
    </div>
    <button mat-raised-button class="navbar-toggler" type="button" (click)="sidebarToggle()">
      <span class="sr-only">Toggle navigation</span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navigation">
      <form class="navbar-form">
        <div class="input-group no-border">
          <button class="upgrade-fab" mat-fab color="warn" (click)="askQuestion()" data-testid="navbar-questions">
            <span class="extended-fab-button__text">Questions?</span>
          </button>
        </div>
      </form>
      <ul class="navbar-nav" style="padding-left: 10px;">
        <li class="nav-item">
          <a class="userprofile" routerLink="/console/profile" data-testid="navbar-user-profile">{{ user?.displayName }}</a>
        </li>
        <li class="nav-item dropdown">
          <app-alerts-icon></app-alerts-icon>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link" style="padding: 10px 5px;" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-testid="navbar-settings">
            <i matBadge="0" [matBadgeHidden]="!showReleaseNotification" class="material-icons hide-text">settings</i>
            <p>
              <span class="d-lg-none d-md-block">Settings</span>
            </p>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
            @if (canSelectOtherCompany) {
              <a class="dropdown-item" routerLink="/company-select">Select other Company</a>
            }
            @if (canSeeCompanyManagement) {
              <a class="dropdown-item" routerLink="/console/company-settings">Edit Company Settings</a>
            }
            <a class="dropdown-item" routerLink="/console/processes">Processes</a>
            <a class="dropdown-item" href="https://planacan.io/release-notes/" target="_blank">Release Notes @if (showReleaseNotification) {
              <span class="new-flag">{{version}}</span>
            }</a>
            @if (canSeeSystemManagement) {
              <a class="dropdown-item" routerLink="/console/system-management">System Management</a>
            }
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
